"use client"

import { useState } from "react"
import { Check, X, Info } from "lucide-react"
import { cn } from "@/lib/utils"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Button } from "@/components/ui/button"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import Header from "../home/Header"
import Footer from "../home/Footer"
import { FAQSection } from "./faqs_growth"
import PricingPageComponent from "@/components/pricing-page"
import Banner from "./free_trial"
import { useIsPando } from "@/components/domainCheck"
import PfPricingPageComponent from "../pf-pricing/pfPricingComponent"
import { FarminstaIntroLayout } from "../home/landing-page"
import { PandoforceLayout } from "../pandoforce/home/layout"
// import { PricingPageComponent } from "@/components/pricing-page"
import SpinnerLoader from '@/app/console/fcm/loader'
import { FarminstaPricing } from "../pricing1/page"


const addOns = [
  {
    title: "Retailer Profile Segmentation",
    dialogTitle: "Locations Add-On",
    dialogDescription: `Location
          Shop name
Name of the shop owner
Servicing Villages/areas
Types of agri-input products
Overall turnover
Company-specific revenue (confidential)
Exclusive retailer (checkbox)`,

    description: `Location,
Shop name,
Name of the shop owner,
Servicing Villages/areas
Types of agri-input products,
Overall turnover

Company-specific revenue (confidential)
Exclusive retailer (checkbox)`
  },
  {
    title: "Track and Manage retailer activities",
    dialogTitle: "Salesforce Integration Add-On",
    dialogDescription: `Retailer meetings:
1. Product samples/ displays
2. Financial discussions (offers/ discount)
3. Live product demos`,
    description: `Retailer meetings:
1. Product samples/ displays
2. Financial discussions (offers/ discount)
3. Live product demos`
  },
  {
    title: "Manage retailer product liquidation",
    dialogTitle: "Manage retailer product liquidation",
    dialogDescription: `Product-wise and SKU-wise details:
1. Current Stock
2. Sold/ liquidation
3. Expected Demand (for supply management)
4. New inventory arrival (from wholesale/ direct manufacturers)`,
    description: `Product-wise and SKU-wise details:
1. Current Stock
2. Sold/ liquidation
3. Expected Demand (for supply management)
4. New inventory arrival (from wholesale/ direct manufacturers)`
  },
  {
    title: "Track and Manage retail sales target",
    dialogTitle: "Track and Manage retail sales layout",
    dialogDescription: `Management can assign specific product targets to each individual.
Field Officers confirm product liquidation and verify the achievement of retail targets.`,
    description: `Management can assign specific product targets to each individual.
Field Officers confirm product liquidation and verify the achievement of retail targets.`
  }
]

const AddOnsComponent = () => {
  return (
    <div className="mt-24">
      <h2 className="text-center text-3xl font-bold text-gray-900 mb-12">
        Customize your Plan with Add-Ons
      </h2>
      <div className="grid gap-4 lg:grid-cols-4 md:grid-cols-2 w-[95%] m-auto">
        {addOns.map((addOn, index) => (
          <div key={index} className="rounded-lg border bg-white p-6 shadow-lg transition-all hover:shadow-xl flex flex-col justify-between">
            <div>
              <div className="flex justify-between items-start mb-4">
                <div>
                  <div className="text-sm font-semibold text-blue-600 mb-2">ADD-ON</div>
                  <h3 className="text-xl font-semibold text-gray-900">{addOn.title}</h3>
                </div>
                <Dialog>
                  <DialogTrigger asChild>
                    <Button variant="ghost" className="p-0 h-auto">
                      <Info className="h-5 w-5 text-gray-400" />
                      <span className="sr-only">{addOn.title}</span>
                    </Button>
                  </DialogTrigger>
                  <DialogContent>
                    <DialogHeader>
                      <DialogTitle>{addOn.dialogTitle}</DialogTitle>
                      <DialogDescription>
                        {addOn.dialogDescription.split('\n').map((item, i) => (
                          <p key={i}>{item}</p>
                        ))}
                      </DialogDescription>
                    </DialogHeader>
                  </DialogContent>
                </Dialog>
              </div>
              <div className="text-gray-600 mb-6">
                {addOn.description.split('\n').map((item, i) => (
                  <p key={i}>{item}</p>
                ))}
              </div>
            </div>
            <Button className="bg-primary hover:bg-secondary text-white w-full mt-auto rounded-sm font-bold transition duration-300 ease-in-out transform hover:scale-105">
              Talk to us
            </Button>
          </div>
        ))}
      </div>
    </div>
  )
}

const Page = () => {
  const isPando = useIsPando();

  if (isPando === null) {
    return <SpinnerLoader />
  }


  if (isPando) {
    return (
      <PandoforceLayout currentPage="pricing" isBookADemo={false}>
        <PfPricingPageComponent />
      </PandoforceLayout>
    );
  }

  return (
    <FarminstaIntroLayout currentPage="price">
      {/*<Banner />*/}
      <FarminstaPricing />
      {/* <AddOnsComponent /> */}
      {/* <FAQSection /> */}
    </FarminstaIntroLayout>
  );
};

export default Page;